module.exports = __webpack_public_path__ + "static/img/title-pk-3.8020a1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/title-pk-3.png
// module id = Fskz
// module chunks = 1